import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import styled from 'styled-components'
import AspectRatio from 'components/AspectRatio'
import Path from 'components/Path'
import classNames from 'classnames'

const Badge = styled.div.attrs({
  className: 'd-flex flex-column text-center align-items-center justify-content-center h-100',
})`
  line-height: 1.2;

  h1 {
    font-size: 5rem;
  }

  p {
    font-size: 3.5rem;
    font-family: 'GT Walsheim Pro Regular';
  }

  .badge-arrow {
    height: 0;
    width: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-top: 30px solid green;
  }
`

const PlotOverview = ({ handleHover = () => {}, hover, image, afangar }) => {
  let { url } = useRouteMatch()

  return (
    <AspectRatio ratio={image.height / image.width}>
      <img src={image.src} alt="" />
      <svg viewBox={`0 0 ${image.width} ${image.height}`}>
        {afangar.map(({ key, title, subtitle, forSale, viewable, path, rect, status }) => (
          <Link
            className="text-decoration-none"
            onMouseEnter={() => handleHover(key)}
            onMouseLeave={() => handleHover(null)}
            key={key}
            to={forSale || viewable ? `${url}/${key}` : url}
          >
            {path ? (
              <Path
                className={classNames(forSale ? 'text-secondary' : 'text-light', path.className)}
                isActive={key === hover}
                d={path.d}
              />
            ) : null}
            {rect ? (
              <>
                <foreignObject {...rect.props}>
                  <Badge className={rect.className}>
                    {status ? (
                      <>
                        <h1 className="m-0">
                          {status === 'planned-allocation' ? 'Fyrirhuguð úthlutun' : ''}
                          {status === 'allocated' ? 'Áfanga úthlutað' : ''}
                        </h1>
                        <p className="m-0">{title}</p>
                      </>
                    ) : status === 'allocated' ? (
                      <h1 className="m-0">Áfanga úthlutað</h1>
                    ) : subtitle ? (
                      <>
                        <h1 className="m-0">{subtitle}</h1>
                        <p className="m-0">{title}</p>
                      </>
                    ) : (
                      <h1 className="m-0">{title}</h1>
                    )}
                  </Badge>
                </foreignObject>
              </>
            ) : null}
          </Link>
        ))}
      </svg>
    </AspectRatio>
  )
}

export default PlotOverview
